import { gql } from "@apollo/client";

export const camerasQuery = gql`
    query CamerasAdmin($page: Int, $sort: SortInput, $status: CameraStatus, $country: String, $query: String, $isRoamingSim: Boolean) {
        camerasAdmin(page: $page, sort: $sort, status: $status, country: $country, query: $query, isRoamingSim: $isRoamingSim) {
            nodes {
                id
                name
                status
                activatedAt
                country
                configurationStatus
                hardwareInfo {
                    imei
                    sn
                    msisdn
                }
                initialActivationAt
                lastActivity
            }
            totalCount
            nextPage
            previousPage
            totalPages
        }
    }
`;
